export default __webpack_public_path__ + "static/media/location.fbf4b29a.svg";